import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.39 11.677a1.135 1.135 0 0 1-1.606 0L.803 8.695a1.135 1.135 0 0 1 0-1.605l2.98-2.981A1.135 1.135 0 1 1 5.39 5.714L4.346 6.757h9.834a1.135 1.135 0 0 1 0 2.27H4.346l1.043 1.044a1.135 1.135 0 0 1 0 1.606",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }